<template>
  <div class="create-new-order">
    <el-form :model="form" label-width="100px">
      <el-form-item label="情况描述">
        <el-input
          v-model="form.description"
          placeholder="请填写情况描述"
        ></el-input>
      </el-form-item>
      <el-form-item label="工单提出人">
        <el-input
          v-model="form.applyName"
          placeholder="请填写工单提出人"
        ></el-input>
      </el-form-item>
      <el-form-item label="工单类型">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option label="维修" value="维修"></el-option>
          <el-option label="巡检" value="巡检"></el-option>
          <el-option label="整改" value="整改"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单期限">
        <el-date-picker
          v-model="form.orderDeadline"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="道路名称">
        <el-input
          v-model="form.orderRoadName"
          placeholder="请填写道路名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="上传图片">
        <el-upload
          action="/common/upload/work"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemove"
          :file-list="fileList"
          :limit="maxCount"
          list-type="picture-card"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>

    <div class="project-section">
      <div class="section-title">所属项目</div>
      <div class="project-list" v-if="projectList.length > 0">
        <div
          v-for="(item, index) in projectList"
          :key="index"
          :class="[
            'project-item',
            index === selectedIdx ? 'project-item-active' : '',
          ]"
          @click="selectedProjectHandle(index)"
        >
          <div class="project-item-content">
            <div class="project-name">{{ item.projectName }}</div>
            <div class="project-manager">
              <i class="el-icon-user"></i>
              {{ item.applyName }}
            </div>
          </div>
          <div class="project-item-icon">
            <i
              :class="
                index === selectedIdx
                  ? 'el-icon-success'
                  : 'el-icon-circle-check'
              "
            ></i>
          </div>
        </div>
      </div>
      <div v-else class="project-list-empty">
        <i class="el-icon-loading" v-if="triggered"></i>
        <span v-else>暂无项目数据</span>
      </div>
    </div>

    <div class="footer">
      <el-button
        type="primary"
        :disabled="selectedIdx === 999"
        @click="orderSubmitHandle"
        style="width: 100%"
      >
        提交给项目经理
      </el-button>
    </div>

    <el-dialog title="提示" :visible.sync="popupShow" width="30%" center>
      <div class="popup-content">
        <i class="el-icon-success" style="font-size: 48px; color: #67c23a"></i>
        <div style="margin-top: 16px; font-size: 18px; font-weight: bold">
          提交成功
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="popupConfirmHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import issuerApi from "@/api/issuer/index.js";

export default {
  name: "CreateNewOrder",
  data() {
    return {
      fileList: [],
      fileListPost: [],
      maxCount: 9,
      form: {
        applyName: "",
        description: "",
        type: "",
        orderDeadline: "",
        projectId: 0,
        photoUrl: "",
        orderRoadName: "",
      },
      projectList: [],
      selectedIdx: 999,
      popupShow: false,
      queryParams: {
        contractName: "",
        managerName: "",
        pageDto: {
          current: 1,
          size: 9999,
        },
        projectName: "",
      },
      triggered: false,
      hasMore: false,
    };
  },
  computed: {
    uploadHeaders() {
      //   return {
      //     'X-ZNGY-TOKEN': getToken()
      //   }
    },
  },
  mounted() {
    this.loadMore();
  },
  methods: {
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.fileList = fileList;
        this.fileListPost.push(response.data.filePath);
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      // 更新fileListPost
      this.fileListPost = this.fileList.map((item) => {
        if (item.response && item.response.data) {
          return item.response.data.filePath;
        }
        return item.url;
      });
    },
    async loadMore() {
      await this.queryBusProjectInfo();
    },
    selectedProjectHandle(idx) {
      this.selectedIdx = idx;
    },
    async queryBusProjectInfo() {
      this.triggered = true;
      console.log("queryParams-->", this.queryParams);
      const res = await issuerApi.queryBusProjectInfo(this.queryParams);
      this.triggered = false;
      this._freshing = false;
      if (res.data.code === 200) {
        console.log("records-->", res.data.data.records);
        this.projectList = this.projectList.concat(res.data.data.records);
        // this.queryParams.pageDto.current += 1;
        // if (this.projectList.length >= res.data.data.total) {
        //   this.hasMore = false;
        // } else {
        //   this.hasMore = true;
        // }
      }
    },
    orderSubmitHandle() {
      this.addBusOrder();
    },
    popupConfirmHandle() {
      this.popupShow = false;
      this.$emit("close");
    },
    async addBusOrder() {
      try {
        // 表单验证（先验证，再设置值）
        if (!this.form.description) {
          this.$message.error("请填写情况描述");
          return;
        }
        if (!this.form.applyName) {
          this.$message.error("请填写工单提出人");
          return;
        }
        if (this.selectedIdx === 999) {
          this.$message.error("请选择所属项目");
          return;
        }
        if (
          this.projectList.length === 0 ||
          !this.projectList[this.selectedIdx]
        ) {
          this.$message.error("项目数据加载中，请稍后重试");
          return;
        }

        this.form.photoUrl = this.fileListPost.join(",");
        this.form.projectId = this.projectList[this.selectedIdx].id;
        console.log("form-->", this.form);
        const res = await issuerApi.addBusOrder(this.form);
        if (res.data.code === 200) {
          this.popupShow = true;
          this.$emit("success");
          this.$message.success("工单创建成功");
        } else {
          this.$message.error(res.data.message || "创建失败");
        }
      } catch (error) {
        console.error("创建工单失败:", error);
        this.$message.error("创建失败，请重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-new-order {
  padding: 20px;
  background-color: #f2f4f7;
  min-height: 100%;

  .project-section {
    margin-top: 20px;

    .section-title {
      padding: 8px 10px;
      font-size: 12px;
      font-weight: bold;
      color: #999999;
    }

    .project-list {
      background-color: #ffffff;
      border-radius: 4px;

      .project-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 10px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;

        &:hover {
          background-color: #f5f7fa;
        }

        .project-item-content {
          flex: 1;

          .project-name {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 20px;
          }

          .project-manager {
            font-size: 13px;
            color: #666666;
            margin-top: 4px;

            i {
              margin-right: 8px;
              color: #adb6d0;
            }
          }
        }

        .project-item-icon {
          i {
            font-size: 16px;
          }
        }
      }

      .project-item-active {
        background-color: #eafcff;
      }
    }

    .project-list-empty {
      background-color: #ffffff;
      border-radius: 4px;
      padding: 40px 20px;
      text-align: center;
      color: #999999;
      font-size: 14px;

      i {
        font-size: 20px;
        margin-right: 8px;
        color: #409eff;
      }
    }
  }

  .footer {
    margin-top: 20px;
    padding: 10px;
  }

  .popup-content {
    text-align: center;
    padding: 20px 0;
  }
}
</style>
